import { PromocodesPageDictionary } from 'types/i18n';

export const promocodesPageDictionaryRu: PromocodesPageDictionary = {
  titleText: 'Промокоды',
  generatePromocodeActionText: 'Сгенерировать промокод',
  searchInputPlaceholderText: 'Поиск по номеру промокода',
};
